import Api from '../services/api.js'
import history from '../history'
import { clearPlan } from './plan'

export function fetchAppTokenRequest(){
  return {
    type: 'FETCH_APP_TOKEN_REQUEST'
  }
}

export function fetchAppTokenSuccess(body){
  return {
    type: 'FETCH_APP_TOKEN_SUCCESS',
    body: body
  }
}

export function fetchAppTokenFailure(exception){
  return {
    type: 'FETCH_APP_TOKEN_FAILURE',
    exception: exception
  }
}

export function clearAppToken() {
  return {
    type: 'CLEAR_APP_TOKEN'
  }
}

export function loggedAsAdmin(is_admin) {
  return {
    type: 'LOG_AS_ADMIN',
    body: is_admin,
  }
}

export function loginRequest(){
  return {
    type: 'LOGIN_REQUEST'
  }
}

export function loginSuccess(body){
  return {
    type: 'LOGIN_SUCCESS',
    body: body
  }
}

export function loginFailure(exception){
  return {
    type: 'LOGIN_FAILURE',
    exception: exception
  }
}

export function refreshUser(body){
  return {
    type: 'REFRESH_USER',
    body: body
  }
}

export function fetchAppToken(credentials) {
  credentials['grant_type'] = "password";
  return dispatch => {
    dispatch(fetchAppTokenRequest())
    const api = new Api();
    return api.post("/oauth/token", credentials)
    .then(response => {
      Promise.all([
        dispatch(fetchAppTokenSuccess(response.data))
      ]).then(() => {
        dispatch(logInWithToken(response.data.access_token))
      });
    })
    .catch(err => dispatch(fetchAppTokenFailure(err)));
  }
}

export function logInWithToken(token) {
  return dispatch => {
    dispatch(loginRequest())
    const api = new Api();
    return api.login("/__api/v1/me", token)
    .then(response => {
      if (response.status===200){
        dispatch(loginSuccess(response.data))
        var is_admin = response.data.is_admin
        dispatch(loggedAsAdmin(is_admin))
        history.push("/dashboard/risk_plans")
      }
    })
    .catch(err => {
      dispatch(loginFailure(err))
      //this will clear the state
      dispatch(clearAppToken())
      history.push("/")
      dispatch(clearPlan())
    });
  }
}

export function logOutToken(token) {
  return dispatch => {
    const api = new Api();
    return api.logout("/oauth/revoke", {token: token})
    .then(response => {
      if (response.status===200){
        //try to log-in again using the same token
        dispatch(logInWithToken(token))
      }
    })
    .catch(err => {});
  }
}



// WEBPACK FOOTER //
// ./src/actions/app_token.js